import { FinxaiTrade } from '../models/finxaiTrade';
import { OrderStatus } from '../models/protobuff-objects/finxai_web_pb';

export type OrderFilterType = 'All' | 'Working' | 'Filled' | 'Partial' | 'Overfilled' | 'Cancelled';

// Helper function to convert OrderStatus enum to readable string
export const getOrderStatusString = (order: FinxaiTrade): string => {
    let status: string = "";

    switch (true) {
        case order.orderStatus === OrderStatus.ORD_STATUS_CANCELED:
            status = "Cancelled";
            break;
        case  order.orderStatus === OrderStatus.ORD_STATUS_NEW || order.orderStatus === OrderStatus.ORD_STATUS_PARTIALLY_FILLED:
            status = "Working";
            break;
        case order.orderStatus === OrderStatus.ORD_STATUS_FILLED:
            status = "Filled";
            break;
        default:
            status = "Unknown";
    }

    return status;

};

// Helper function to filter orders by type
export const filterOrdersByType = (orders: FinxaiTrade[], filterType: OrderFilterType): FinxaiTrade[] => {
    return orders.filter(order => {
        var isZeroCancelled = order.orderStatus === OrderStatus.ORD_STATUS_CANCELED && order.filled_qty === 0;
        var isCancelled = order.orderStatus === OrderStatus.ORD_STATUS_CANCELED;
        
        switch (filterType) {
            case 'Filled':
                return order.orderStatus === OrderStatus.ORD_STATUS_FILLED;
            case 'Working':
                return order.orderStatus === OrderStatus.ORD_STATUS_NEW || order.orderStatus === OrderStatus.ORD_STATUS_PARTIALLY_FILLED;
            case 'Cancelled':
                return isZeroCancelled;
            default:
                return !isZeroCancelled;
        }
    });
};
